﻿function initUniversalNavbar() {
    function submitSearchQuery(query) {
        let url = window.location.protocol + '//' + window.location.host + '/search?searchTerm=' + query;
        window.location.href = url;
    }


    function showSearch() {
        gsap.set('.navbarSearchOverlay', { autoAlpha: 1, display: 'block' });
        gsap.fromTo('#navbarSearchOverlayForm', { opacity: 0, y: -35 }, { opacity: 1, y: 0, onComplete: focusSearch });
        
    }

    function focusSearch() {
        $('#navbarSearchOverlayInput').focus();
        $('#navbarSearchOverlayInput').trigger('touchstart');
    }

    function hideSearch() {
        gsap.fromTo('#navbarSearchOverlayForm', { opacity: 1, y: 0 }, { opacity: 0, y: -35 });
        gsap.set('.navbarSearchOverlay', { display: 'none' }, .6);
    }

    $('[data-navbar-search-toggle]').on('click', function (event) {
        event.preventDefault();
        showSearch();
    })

    $('.navbarSearchOverlay').on('click', function (event) {
        hideSearch();
    })

    $('#navbarSearchOverlayInput').on('click', function (event) {
        event.stopPropagation();
    })

    $('#navbarSearchOverlayForm').on('submit', function (event) {
        event.preventDefault();
        submitSearchQuery($('#navbarSearchOverlayInput').val());
    })

}

initUniversalNavbar();